import { render, staticRenderFns } from "./Multiview.vue?vue&type=template&id=09a90b55"
import script from "./Multiview.vue?vue&type=script&lang=js"
export * from "./Multiview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports